import React, { useState } from 'react';
import logo from '../assets/images/afya.jpg';
import { Link } from 'react-scroll';

export default function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="sticky top-0 z-50 backdrop-blur-md bg-secondary/70 border border2-primary rounded-3xl w-11/12 md:w-8/12 mx-auto mt-4">
      <nav className="max-w-screen-xl mx-auto p-2 flex flex-wrap items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center space-x-3 rtl:space-x-reverse">
          <img src={logo} className="h-12 rounded-full" alt="Afya Ustawi" />
          <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">
            Afya Ustawi
          </span>
        </a>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>

        {/* Menu */}
        <div
          className={`w-full md:w-auto md:flex md:items-center ${
            isOpen ? 'block' : 'hidden'
          }`}
        >
          <ul className="font-light text-white text-sm flex flex-col p-4 md:p-0 mt-4 md:flex-row md:space-x-8 md:mt-0 md:border-0 mr-4">
            {[
              { name: 'Home', to: 'home' },
              { name: 'About', to: 'about' },
              { name: 'Services', to: 'objectives' },
              { name: 'Programmes', to: 'programmes' },
               { name: 'Events', to: 'events' },
              { name: 'Contact Us', to: 'footer' },
            ].map((item, idx) => (
              <li key={idx}>
                <Link
                  to={item.to}
                  smooth={true}
                  duration={600}
                  className="cursor-pointer block py-2 px-3 text-gray-900 md:text-gray-100 md:p-0 hover:text-yellow-400"
                  onClick={() => setIsOpen(false)} // close menu on click
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
}
